var Reverb = window.Reverb || {};

Reverb.Messages = (function () {
  function showReplyOnSubmitSuccess() {
    $('form.threaded-messages[data-remote]').bind('ajax:beforeSend', function () {
      var form = $(this);
      var replyText = form.find('textarea').val();
      var thread = form.parents('ul.threaded');
      var newRow = thread.find('li.empty').clone();
      appendReply(thread, newRow, replyText);
    });
  }

  function appendReply($thread, $newRow, replyText) {
    $newRow.removeClass('empty').addClass('message');
    $newRow.find('.subject').html(replyText.replace(/\r\n|\r|\n/g, '<br />'));
    $newRow.find('.date').text('Just now');
    $thread.find('li.message:last').after($newRow);
    $thread.parents('li.message').find('.badge').fadeOut();
    $newRow.fadeIn();
  }

  function init() {
    showReplyOnSubmitSuccess();
  }

  return {
    init: init
  };
})();

$(document).ready(function () {
  Reverb.Messages.init();
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/dashboard/messages.js